var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtArrowPagLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 63.8L.3 32 41.3.2l1.4 1.6L3.7 32l39 30.2z"
  })));
}
export default SvgFtArrowPagLeft;